// VideoEmbed.js
import React from 'react';

const VideoEmbed = ({ url }) => {
    // Extract the video ID from the URL
    const videoId = new URL(url).searchParams.get('v');

    if (!videoId) {
        return <div>Invalid YouTube URL</div>;
    }

    // Construct the embed URL
    const embedUrl = `https://www.youtube.com/embed/${videoId}`;

    return (
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
            <iframe
                src={embedUrl}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                }}
            />
        </div>
    );
};

export default VideoEmbed;
